
@if(isDownloading) {
<kzn-loader message="Downloading file..."></kzn-loader>
} @else if(!isView && (isSigned || isSubmitted || isDeclined)) {
<kzn-status-message [heading]="statusMessage.heading" [message]="statusMessage.message"
  [isSuccess]="statusMessage.isSuccess"></kzn-status-message>
} @else if(isError) {
<kzn-status-message [heading]="statusMessage.heading" [message]="statusMessage.message"
  [isSuccess]="statusMessage.isSuccess"></kzn-status-message>
} @else if(base64 && (isERSDAccepted || isView)) {
@if (isView && isMobileView) {
  <div class="view-mobile-banner">
    <span class="view-mobile-banner__status">{{ t('viewCompleted') }}</span>
    <span class="view-mobile-banner__text">{{ t('viewNoFurtherAction') }}</span>
  </div>
}
<div class="btn__next__conatiner" id="btn__next"
  [class.show]="hasSignHereElements && !isView && !isReviewer && !tagDragHidesNext"
  [class.hidden]="!hasSignHereElements || isView || tagDragHidesNext"
  (click)="nextSignTagHandler()">{{ t('next') }}</div>
<div class="pdf-viewer-container" [class.view-mode]="isView" [class.view-mode-mobile]="isView && isMobileView" [class.reviewer-mode]="isReviewer" [class.mobile-toolbar-expanded]="isMobileToolbarExpanded"
  [class.sign-mode]="!isView" [class.compact-mode]="isCompactView"
  (dragover)="onPdfDragOver($event)" (drop)="onPdfDrop($event)">

  @if (!pdfReady) {
  <div class="pdf-loading-overlay">
    <kzn-loader message="Loading document..."></kzn-loader>
  </div>
  }

  @if (!isView && kapybaraRevealed()) {
  <img src="assets/kapybara.png" alt="Kapybara" class="kapybara-mascot"
    (click)="toggleKapybaraSidebar()" />
      <button type="button" class="close-icon-style" (click)="onKapybaraHeaderClick1()">
    <mat-icon class="font-size: 16px !important;">close</mat-icon>
  </button>
}
   

  @if (!isView) {
  <div class="kapybara-sidebar-backdrop" [class.show]="kapybaraSidebarOpen"
    (click)="closeKapybaraSidebar()"></div>
  <aside class="kapybara-sidebar" [class.show]="kapybaraSidebarOpen">
    <div class="kapybara-sidebar__header">
      <div class="kapybara-sidebar__header-left">
        <div class="kapybara-avatar-wrap">
          <img src="assets/kapybara.png" alt="Kapybara" class="kapybara-avatar" />
        </div>
        <div>
          <h3>{{ t('assistantName') }}</h3>
          <span class="kapybara-tagline">{{ t('assistantActive') }}</span>
        </div>
      </div>
      <button type="button" class="kapybara-sidebar__close" (click)="closeKapybaraSidebar()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="kapybara-sidebar__content">
      <div class="kapybara-sidebar__scroll" #kapybaraSidebarScroll>
      <details class="kapybara-section kapybara-doc-info" [attr.open]="showDocInfoSection ? '' : null">
        <summary (click)="showDocInfoSection = !showDocInfoSection; $event.preventDefault()">
          <mat-icon>description</mat-icon>
          <span>{{ t('pdfDocInfoTitle') }}</span>
          <mat-icon>{{ showDocInfoSection ? 'expand_less' : 'expand_more' }}</mat-icon>
        </summary>
        <div class="kapybara-doc-info__body">
          <div class="kapybara-doc-info__row">
            <span class="kapybara-doc-info__label">{{ t('pdfDocInfoName') }}</span>
            <span class="kapybara-doc-info__value">{{ fileName || 'Document' }}</span>
          </div>
          @if (documentRequesterName || documentCustomerName) {
          <div class="kapybara-doc-info__row">
            <span class="kapybara-doc-info__label">{{ t('pdfDocInfoSentBy') }}</span>
            <span class="kapybara-doc-info__value">{{ documentRequesterName }}{{ documentCustomerName ? ' (' + documentCustomerName + ')' : '' }}</span>
          </div>
          }
          <div class="kapybara-doc-info__how">
            <span class="kapybara-doc-info__how-title">{{ t('pdfDocInfoHowToAddTitle') }}</span>
            <ol class="kapybara-doc-info__steps">
              <li>{{ t('pdfDocInfoHowToAddStep1') }}</li>
              <li>{{ t('pdfDocInfoHowToAddStep2') }}</li>
              <li>{{ t('pdfDocInfoHowToAddStep3') }}</li>
              <li>{{ t('pdfDocInfoHowToAddStep4') }}</li>
            </ol>
            <p class="kapybara-doc-info__where">
              <strong>{{ t('pdfDocInfoWhereFrom') }}</strong> {{ t('pdfDocInfoWhereFromDesc') }}
            </p>
          </div>
        </div>
      </details>

      <details class="kapybara-section" [attr.open]="showPdfSuggestionsSection ? '' : null">
        <summary (click)="showPdfSuggestionsSection = !showPdfSuggestionsSection; $event.preventDefault()">
          <mat-icon>auto_awesome</mat-icon>
          <span>{{ t('pdfSuggestionsTitle') }}</span>
          <mat-icon>{{ showPdfSuggestionsSection ? 'expand_less' : 'expand_more' }}</mat-icon>
        </summary>
      @if (pdfSuggestionsLoading) {
      <div class="pdf-suggestions-loading">
        <mat-icon class="spin">hourglass_empty</mat-icon>
        <span>{{ t('pdfSuggestionsScanning') }}</span>
      </div>
      } @else if (pdfFieldSuggestions.length > 0) {
      <div class="pdf-suggestions-list">
        <p class="pdf-suggestions-intro">{{ t('pdfDrawerWhereToAdd') }}</p>
        @for (g of pdfGroupedSuggestions; track g.page + g.matchedText + g.fieldTypes.join(',')) {
        <div class="pdf-suggestion-card">
          <div class="pdf-suggestion-card__header">
            <mat-icon class="pdf-suggestion-card__icon">{{ getSuggestionFieldIcon(g.fieldTypes[0]) }}</mat-icon>
            <span class="pdf-suggestion-card__field">{{ t('pdfDrawerAddHere') }} {{ formatFieldTypesLabel(g.fieldTypes) }}</span>
          </div>
          <p class="pdf-suggestion-card__context">{{ t('pdfDrawerSignPosition', { page: g.page }) }} "{{ (g.matchedText || '').slice(0, 50) }}{{ (g.matchedText || '').length > 50 ? '…' : '' }}"</p>
        </div>
        }
      </div>
      } @else {
      <div class="pdf-suggestions-general">
        <p class="pdf-suggestions-general-title">{{ t('pdfDrawerGeneralSuggestions') }}</p>
        <ul class="pdf-suggestions-general-list">
          <li>{{ t('pdfDrawerSuggestion1') }}</li>
          <li>{{ t('pdfDrawerSuggestion2') }}</li>
          <li>{{ t('pdfDrawerSuggestion3') }}</li>
        </ul>
      </div>
      }
      </details>

      <details class="kapybara-section" [attr.open]="showPdfInsightsSection ? '' : null">
        <summary (click)="showPdfInsightsSection = !showPdfInsightsSection; $event.preventDefault()">
          <mat-icon>plagiarism</mat-icon>
          <span>PDF Insights</span>
          <mat-icon>{{ showPdfInsightsSection ? 'expand_less' : 'expand_more' }}</mat-icon>
        </summary>
        @if (pdfInsightsLoading) {
          <div class="pdf-suggestions-loading">
            <mat-icon class="spin">hourglass_empty</mat-icon>
            <span>Reading PDF…</span>
          </div>
        } @else if (pdfInsightsError) {
          <p class="kapybara-sidebar__hint">Couldn’t read text from this PDF.</p>
        } @else if (pdfInsights?.previewText) {
          <div class="pdf-insights">
            <div class="pdf-insights__preview">
              <div class="pdf-insights__label">Preview</div>
              <div class="pdf-insights__text">{{ pdfInsights?.previewText }}</div>
            </div>

            @if ((pdfInsights?.entities?.emails?.length ?? 0) > 0) {
              <div class="pdf-insights__block">
                <div class="pdf-insights__label">Emails</div>
                <div class="pdf-insights__chips">
                  @for (e of pdfInsights!.entities.emails; track e) {
                    <span class="pdf-insights__chip">{{ e }}</span>
                  }
                </div>
              </div>
            }

            @if ((pdfInsights?.entities?.phones?.length ?? 0) > 0) {
              <div class="pdf-insights__block">
                <div class="pdf-insights__label">Phones</div>
                <div class="pdf-insights__chips">
                  @for (p of pdfInsights!.entities.phones; track p) {
                    <span class="pdf-insights__chip">{{ p }}</span>
                  }
                </div>
              </div>
            }

            @if ((pdfInsights?.entities?.dates?.length ?? 0) > 0) {
              <div class="pdf-insights__block">
                <div class="pdf-insights__label">Dates</div>
                <div class="pdf-insights__chips">
                  @for (d of pdfInsights!.entities.dates; track d) {
                    <span class="pdf-insights__chip">{{ d }}</span>
                  }
                </div>
              </div>
            }

            @if ((pdfInsights?.entities?.amounts?.length ?? 0) > 0) {
              <div class="pdf-insights__block">
                <div class="pdf-insights__label">Amounts</div>
                <div class="pdf-insights__chips">
                  @for (a of pdfInsights!.entities.amounts; track a) {
                    <span class="pdf-insights__chip">{{ a }}</span>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <p class="kapybara-sidebar__hint">No readable text found in this PDF.</p>
        }
      </details>

      <div class="kapybara-welcome">
        <div class="kapybara-msg">
          <img src="assets/kapybara.png" alt="" class="kapybara-msg-avatar" />
          <div class="kapybara-msg-bubble">
            <p>{{ t('assistantWelcomeDetailed', { name: signerName || t('user'), fields: signService.allTagsCount }) }}</p>
            <div class="kapybara-msg-actions">
              <button mat-stroked-button color="primary" (click)="handleAssistantAction('startTour')">
                <mat-icon>flag</mat-icon>
                {{ t('assistantStartTour') }}
              </button>
              <button mat-stroked-button (click)="handleAssistantAction('showTips')">
                <mat-icon>tips_and_updates</mat-icon>
                {{ t('assistantQuickTips') }}
              </button>
            </div>
          </div>
        </div>
      </div>

      @if (assistantResponseShimmer || assistantResponseText) {
      <div class="kapybara-response" #responseBlock [class.kapybara-response--shimmer]="assistantResponseShimmer">
        @if (assistantResponseShimmer) {
        <div class="kapybara-response-shimmer">
          <div class="shimmer-line"></div>
          <div class="shimmer-line"></div>
          <div class="shimmer-line shimmer-line--short"></div>
        </div>
        } @else if (assistantResponseText) {
        <div class="kapybara-response-content">
          <img src="assets/kapybara.png" alt="" class="kapybara-msg-avatar" />
          <div class="kapybara-msg-bubble kapybara-response-bubble">
            <p class="kapybara-response-text">{{ assistantResponseText }}</p>
          </div>
        </div>
        }
      </div>
      }
      <div class="kapybara-chat">
        <form class="kapybara-chat__input" (submit)="sendKapybaraChat(); $event.preventDefault()">
          <div class="kapybara-chat__input-row">
            <input
              type="text"
              [(ngModel)]="kapybaraChatInput"
              name="kapybaraChatInput"
              class="kapybara-chat__textbox"
              placeholder="Ask me anything..."
              autocomplete="off"
            />
            <button type="submit" class="kapybara-chat__send" [disabled]="!(kapybaraChatInput || '').trim()">
              <mat-icon>send</mat-icon>
            </button>
          </div>
        </form>

        <div class="kapybara-chat__messages" #kapybaraChatMessagesContainer>
          @for (m of kapybaraChatMessages; track m.id) {
            <div class="kapybara-chat__msg" [class.is-user]="m.role === 'user'">
              <div class="kapybara-chat__bubble" [class.is-typing]="m.isTyping">
                @if (m.isTyping) {
                  <span class="kapybara-chat__typing-dot"></span>
                  <span class="kapybara-chat__typing-dot"></span>
                  <span class="kapybara-chat__typing-dot"></span>
                } @else {
                  {{ m.text }}
                }
              </div>
            </div>
          }
        </div>
      </div>
      </div>
    </div>
  </aside>
  }

  <ngx-extended-pdf-viewer 
    [base64Src]="base64"
    [showToolbar]="isCompactView && !isView"
    [handTool]="false"
    [maxZoom]="4"
    (currentZoomFactor)="onZoomFactorChange($event)"
    (annotationEditorLayerRendered)="onAnnotationLayerRendered($event)"
    (annotationLayerRendered)="onAnnotationLayerRendered($event)"
    [customToolbar]="!isView && isCompactView ? additionalButtons : emptyToolbar" [showUnverifiedSignatures]="true"
    (pagesLoaded)="pagesLoaded($event)" [pageViewMode]="pageViewMode" (pageRendered)="onPageRendered($event)"
    (textLayerRendered)="onTextLayerRendered($event)"
    [showSidebarButton]="false" [showHandToolButton]="false" [zoom]="'auto'">
  </ngx-extended-pdf-viewer>

  @if (!isView) {
  @if (pdfLoaded && pdfReady && endPanelDelayPassed) {
  <div class="pdf-additional-info-section" #additionalInfoSection
    [class.show]="showDrawerPanel">
    <div class="pdf-custom-page">
      <button type="button" class="info-close-btn" (click)="closeAdditionalInfo(); $event.stopPropagation()">
        <mat-icon>close</mat-icon>
      </button>
      <h3>{{ t(isReviewer ? 'reviewHeadingReviewer' : 'reviewHeading') }}</h3>
      <p>
        {{ t('reviewBody') }}
      </p>
      @if (!isView) {
      <div class="document-action-buttons">
        <div class="button-group">
          <button mat-button class="decline-btn" (click)="openDeclineConfirmationDialog()"
            [disabled]="isSubmitted || isDeclined || isSigned">
            <mat-icon>cancel</mat-icon>
            {{ t('decline') }}
          </button>
          <button mat-raised-button color="primary" class="submit-btn" (click)="signPDF()"
            [disabled]="isSubmitted || isDeclined || isSigned">
            <mat-icon>check_circle</mat-icon>
            {{ t('submit') }}
          </button>
        </div>
      </div>
      }
    </div>
  </div>
  }
  }
</div>


<ng-template #additionalButtons>
  @if(!isView) {
    <div id="toolbarViewer" [class.mobile-expanded]="isMobileToolbarExpanded">
      <div id="toolbarViewerLeft">
        <div class="toolbar__left-custom">
          @for(item of visibleToolbarItems; track item.key) {
            <div class="toolbar__left-custom-item" (click)="onToolbarItemClick(item)"
              (touchstart)="onToolbarItemTouchStart($event, item)"
              (pointerdown)="onToolbarItemPointerDown($event, item)"
              [attr.draggable]="item.kind === 'tag' && !isToolbarItemDisabled(item) ? true : null"
              (dragstart)="onToolbarItemDragStart($event, item)"
              [ngClass]="{'disabled': isToolbarItemDisabled(item)}">
              <img class="sign-toolbar-icon" [src]="toolbarIcon(item)" alt="" />
              <span>{{ t(item.labelKey) }}</span>
            </div>
          }
          @if(showMobileMoreToggle) {
            <div class="toolbar__left-custom-item more-toggle" (click)="toggleMobileToolbar()">
              <mat-icon color="primary">
                {{ isMobileToolbarExpanded ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </div>
          }
        </div>
      </div>
      <div id="toolbarViewerRight">
        <div class="document-action-btn-container">
        </div>
      </div>
    </div>
  }
</ng-template>

<ng-template #emptyToolbar>
  <div></div>
</ng-template>

<ng-template #viewToolbar>
  @if(isView) {
  <div id="toolbarViewer">
    <div id="toolbarViewerMiddle">
      <pdf-find-button [showFindButton]="true" [textLayer]="true"></pdf-find-button>
    </div>
  </div>
  }
</ng-template>
}